import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShopListTypes, SelectedShop, Shop } from 'models';

export interface LoginPayload {
  email: string;
  password: string;
  role: number;
  remember_me: boolean;
}
interface InitialState {
  selectShop: SelectedShop;
  listShop: Shop[];
  listShopLoading: boolean;
}
const savedShop = typeof window !== 'undefined' ? localStorage.getItem('selectedShop') : null;
const initialState: InitialState = {
  listShop: [],
  listShopLoading: true,
  selectShop: savedShop ? JSON.parse(savedShop) : ({} as SelectedShop),
};

const shopListSlice = createSlice({
  name: 'shopList',
  initialState,
  reducers: {
    fetchShopList(state, action: PayloadAction<{ token: string | undefined }>) {
      //   state.logging = true;
      state.listShopLoading = true;
    },

    fetchShopListSuccess(state: any, action: PayloadAction<any>) {
      state.listShop = action.payload;
      state.listShopLoading = false;
      // const idShopSelect = localStorage.getItem('POS_CUSTOMER_PAYMENT_SELECTED_SHOP');

      // if (idShopSelect) {
      //   const item = action.payload.find((item: any) => item.id === Number(idShopSelect));
      //   if (item?.id) {
      //     state.selectShop = item;
      //   } else {
      //     state.selectShop = action.payload[0];
      //   }
      // } else {
      //   state.selectShop = action.payload[0];
      // }
      // localStorage.setItem('POS_CUSTOMER_PAYMENT_SELECTED_SHOP', state.selectShop?.id);
    },
    fetchShopListFailed(state: any) {
      state.listShop = initialState.listShop;
      state.listShopLoading = false;
    },
    fetchAllBillListByShop(
      state,
      action: PayloadAction<{ token: string | undefined; params: any }>
    ) {
      // console.log('fetchAllBillListByShop');
    },

    // fetchAllBillListByShopSuccess(state, action: PayloadAction<any>) {
    //   state.listBillShop = action.payload;
    // },

    setSelectShop(state, action: PayloadAction<any>) {
      const selected = state.listShop.find((i: any) => `${i.id}` === `${action.payload}`);
      state.selectShop = selected ?? {};

      if (selected) {
        localStorage.setItem('selectedShop', JSON.stringify(selected));
        localStorage.setItem('ID_SELECTED_SHOP', JSON.stringify(selected?.id));
      }
    },

    masterEnableShopPermissionStaffSuccess(
      state,
      action: PayloadAction<
        Array<{
          name: string;
          active: number;
          app_name: Array<number>;
          shop_id: number;
          id?: number;
        }>
      >
    ) {
      if (!Array.isArray(action.payload)) return;
      state.listShop = state.listShop.map((shop) => {
        const foundItem = action.payload.find((item) => item.shop_id === shop.id);
        if (!foundItem) return shop;
        return {
          ...shop,
          active: foundItem.active,
        };
      });
    },
    removeShopList(state) {
      state.listShop = [];
    },
  },
});

// Actions
export const shopListAction = shopListSlice.actions;
// Selectors
export const selectShopList = (state: any) => state.shopList;

// Reducer
const shopListReducer = shopListSlice.reducer;
export default shopListReducer;
